import differenceBy from "lodash/differenceBy";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";

import Entity from "../../shared/components/Entity";
import VirtualizedTable from "../../shared/components/VirtualizedTable";
import { MIN_WIDTH_CHECKBOX, MIN_WIDTH_ENTITIES } from "../../shared/constants";
import { parseName } from "../../shared/utils";
import { POLICIES_TABLE_ROW_HEIGHT } from "../constants";
import PoliciesTableFilter from "../containers/PoliciesTableFilter";
import PoliciesTableItem from "../containers/PoliciesTableItem";
import PoliciesTableRoleLink from "../containers/PoliciesTableRoleLink";
import RoleHeading from "../containers/RoleHeading";
import { EntityShape, RoleShape } from "../proptypes";

class PoliciesTable extends Component {
  state = {
    rolesToFilter: []
  };

  handleFilterRoles = (role, show) => {
    const { rolesToFilter } = this.state;

    const newRolesToFilter = show
      ? rolesToFilter.filter(f => f.$uri !== role.$uri)
      : [...rolesToFilter, role];
    this.setState({
      rolesToFilter: newRolesToFilter
    });
  };

  headerRenderer = column => {
    const { setSortState, sortBy } = this.props;
    const { key, label, roleUri } = column;

    if (key === "entity") {
      return (
        <div className="p-table__cell">
          <PoliciesTableFilter setSortState={setSortState} sortBy={sortBy} />
        </div>
      );
    }

    return <PoliciesTableRoleLink roleUri={roleUri} label={label} />;
  };

  cellRenderer = (column, entity) => {
    const { name, policies, type } = entity;
    const { key, roleUri } = column;
    const { name: parsedName, domain } = parseName(name);

    if (key === "entity") {
      return (
        <div className="p-table__cell--bordered">
          <Link
            className="u-hide-text-overflow"
            to={`/policies/groups/${parsedName}`}
          >
            <Entity type={type} domain={domain}>
              {parsedName}
            </Entity>
          </Link>
        </div>
      );
    }

    const existingPolicy = policies.find(
      policy => policy.role && policy.role.$ref === roleUri
    );

    return (
      <div className="p-table__cell--bordered">
        <PoliciesTableItem
          entity={entity}
          policy={existingPolicy}
          roleUri={roleUri}
        />
      </div>
    );
  };

  render() {
    const { entities, roles, canEditUsers } = this.props;
    const { rolesToFilter } = this.state;
    const filteredRoles = differenceBy(roles, rolesToFilter, "$uri");
    const columns = [
      { key: "entity", label: "", minWidth: MIN_WIDTH_ENTITIES },
      ...filteredRoles.map(role => ({
        key: role.label,
        label: role.label,
        roleUri: role.$uri,
        minWidth: MIN_WIDTH_CHECKBOX
      }))
    ];
    const heading = entities.length
      ? `Groups & Users [${entities.length}]`
      : "Groups & Users";
    const url = entities.length
      ? `/policies/groups/${entities[0].name}`
      : "/policies/groups";
    return (
      <div className="l-policies__column" style={{ gridArea: "policies" }}>
        <div className="l-policies__column-header">
          <div>
            <Link className="p-button--link p-muted-heading" to={url}>
              {heading}
            </Link>
            {canEditUsers && (
              <Link
                to="/policies/groups/add"
                data-role="add-user-button"
                className="p-button p-button--thin"
              >
                <span>
                  <i className="p-icon--plus" />
                  <span className="p-icon__text">Add</span>
                </span>
              </Link>
            )}
          </div>
          <RoleHeading roles={roles} filterRole={this.handleFilterRoles} />
        </div>
        <div className="l-policies__table">
          <VirtualizedTable
            cellRenderer={this.cellRenderer}
            columns={columns}
            defaultRowHeight={POLICIES_TABLE_ROW_HEIGHT}
            headerOverflow={250}
            headerRenderer={this.headerRenderer}
            rows={entities}
          />
        </div>
      </div>
    );
  }
}

PoliciesTable.propTypes = {
  entities: PropTypes.arrayOf(EntityShape).isRequired,
  roles: PropTypes.arrayOf(RoleShape).isRequired,
  canEditUsers: PropTypes.bool.isRequired,
  setSortState: PropTypes.func.isRequired,
  sortBy: PropTypes.string
};

PoliciesTable.defaultProps = {
  sortBy: undefined
};

export default PoliciesTable;
